



































require("@/assets/css/admin-card.scss");
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class PinboardListCard extends Vue{
    categoryColor:string = "#EDDDD4"
}
